<section class="page page-site-desabilitado">
  <div class="bg degrade-roxo"></div>
  <div class="content">
    <h1 class="animated bounceIn">Logo o site estará no ar!</h1>
    <h2 class="animated bounceInUp">Estamos modificando algumas coisas.</h2>
  </div>  
</section>
